<template>
    <div class="video-section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8 text-center wow animate__animated animate__fadeInUp">
                    <div class="video-section__label">
                        <span class="video-section__label-line"></span>
                        <span class="video-section__label-text">Conheça nosso trabalho</span>
                        <span class="video-section__label-line"></span>
                    </div>
                    <div class="video-section__wrapper">
                        <video width="100%" controls>
                            <source
                                src="@/assets/img/video-3.mp4"
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.video-section {
    padding: 100px 0;
    background-color: $marfim;
    position: relative;

    &__label {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        margin-bottom: 40px;

        &-line {
            display: block;
            width: 40px;
            height: 1px;
            background-color: $caramelo;
        }

        &-text {
            font-family: $font-body;
            font-weight: 500;
            font-size: 12px;
            letter-spacing: 3px;
            text-transform: uppercase;
            color: $caramelo;
        }
    }

    &__wrapper {
        position: relative;

        video {
            width: 100%;
            border: 3px solid rgba($caramelo, 0.15);
            box-shadow: 0 20px 60px rgba($marrom-escuro, 0.08);
        }
    }
}

@media (max-width: 575.98px) {
    .video-section {
        padding: 60px 0;
    }
}
</style>
